<script setup>

const props = defineProps({
    items: {
        type: Array,
        required: true
    }
})

const emit = defineEmits(['show'])


function show(id){
    emit('show', id)
}

function formatTime(datetime){
    return dayjs(datetime).format('YYYY-MM-DD')
}


</script>


<template>
    <table v-if="items.length" class="table-auto  w-full overflow-auto border-separate border-1">
        <thead>
        <tr>
            <th>Publish at</th>
            <th>Title</th>
            <th>Confirm</th>
            <th></th>
            <th></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="item in items">
            <tr class="text-center hover:bg-gray-200">
                <td><div class="font-bold text-sm">{{formatTime(item.created_at)}}</div></td>
                <td class="truncate max-w-[80px]">{{ item.title }}</td>
                <td><button >{{ item.read.length ? '✅' : '👀' }}</button></td>
                <td><button @click="show(item.id)" class="px-2 py-1 bg-yellow-400 hover:bg-yellow-500 text-gray-50 rounded">view</button></td>
            </tr>
        </template>
        </tbody>
    </table>
    <div v-else class="text-center">no data, please try other conditions</div>

</template>
